import { render, staticRenderFns } from "./editAffiliateRule.vue?vue&type=template&id=44a1b6dd"
import script from "./editAffiliateRule.vue?vue&type=script&lang=js"
export * from "./editAffiliateRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports